import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Header, Image, Modal } from 'semantic-ui-react';

import { Box, Flex } from 'src/Components/Base';

import { BrowseUniversity } from 'src/Containers/BrowseUniversity';

export default class BrowseDepartmentModal extends Component {
  static propTypes = {
    onClose: PropTypes.func,
  };

  static defaultProps = {
    onClose: () => {},
  };

  render() {
    const { open, onClose, mockExam, roundCode, onDepartmentClick } = this.props;
    return (
      <Modal
        // className={'scrolling'}
        dimmer="inverted"
        open={open}
        onClose={onClose}
      >
        <Modal.Header style={{ fontWeight: 500 }}>เลือกคณะที่สอบติด</Modal.Header>
        <Modal.Content style={{ padding: 0 }}>
          <Modal.Description>
            <BrowseUniversity
              hideHeart
              // showClose
              hideRounds
              onClose={onClose}
              // roundCode={roundCode}
              onDepartmentClick={onDepartmentClick}
            />
          </Modal.Description>
        </Modal.Content>
      </Modal>
    );
  }
}
